import { render, staticRenderFns } from "./FormZonesShipping.vue?vue&type=template&id=4e417353&scoped=true&lang=pug&"
import script from "./FormZonesShipping.vue?vue&type=script&lang=js&"
export * from "./FormZonesShipping.vue?vue&type=script&lang=js&"
import style0 from "./FormZonesShipping.vue?vue&type=style&index=0&id=4e417353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e417353",
  null
  
)

/* custom blocks */
import block0 from "./FormZonesShipping.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VRow,VSpacer})
